/***************************************
	Polyfills
***************************************/

if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function(s) {
		var el = this;
		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

if (typeof Object.assign != 'function') {
	Object.defineProperty(Object, "assign", {
		value: function assign(target, varArgs) {
			'use strict';
			if (target == null) {
				throw new TypeError('Cannot convert undefined or null to object');
			}

			var to = Object(target);
			for (var index = 1; index < arguments.length; index++) {
				var nextSource = arguments[index];
				if (nextSource != null) {
					for (var nextKey in nextSource) {
						if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
							to[nextKey] = nextSource[nextKey];
						}
					}
				}
			}
			return to;
		},
		writable: true,
		configurable: true
	});
}

if (!String.prototype.includes) {
	String.prototype.includes = function(search, start) {
		'use strict';
		if (typeof start !== 'number') {
			start = 0;
		}

		if (start + search.length > this.length) {
			return false;
		} else {
			return this.indexOf(search, start) !== -1;
		}
	};
}

(function() {
	function trim(s) {
		return s.replace(/^\s+|\s+$/g, '');
	}
	
	function regExp(name) {
		return new RegExp('(^|\\s+)'+ name +'(\\s+|$)');
	}

	function forEach(list, fn, scope) {
		for (var i = 0; i < list.length; i++) {
			fn.call(scope, list[i]);
		}
	}

	function ClassList(element) {
		this.element = element;
		this.isSVG = this.element instanceof SVGElement;
	}

	ClassList.prototype = {
		add: function() {
			forEach(arguments, function(name) {
				if (!this.contains(name)) {
					if (this.isSVG)	this.element.className.baseVal = trim(this.element.className.baseVal +' '+ name);
					else 			this.element.className = trim(this.element.className +' '+ name);
				}
			}, this);
		},
		remove: function() {
			forEach(arguments, function(name) {
				if (this.isSVG) this.element.className.baseVal = trim(this.element.className.baseVal.replace(regExp(name), ' '));
				else 			this.element.className = trim(this.element.className.replace(regExp(name), ' '));
			}, this);
		},
		toggle: function(name, state) {
			if (typeof state !== 'undefined') {
				if (state) this.add(name);
				else 	   this.remove(name);

				return state;
			}

			return this.contains(name) ? (this.remove(name), false) : (this.add(name), true);
		},
		contains: function(name) {
			var className = this.isSVG ? this.element.className.baseVal : this.element.className;
			return regExp(name).test(className);
		},
		item: function(i) {
			var className = this.isSVG ? this.element.className.baseVal : this.element.className;
			return className.split(/\s+/)[i] || null;
		},
		replace: function(oldName, newName) {
			this.remove(oldName), this.add(newName);
		}
	};

	if (!('classList' in Element.prototype)) {
		Object.defineProperty(Element.prototype, 'classList', {
			get: function() {
				return new ClassList(this);
			}
		});
	}

	if (window.DOMTokenList && !DOMTokenList.prototype.replace) {
		DOMTokenList.prototype.replace = ClassList.prototype.replace;
	}
})();


if (!Array.prototype.fill) {
	Object.defineProperty(Array.prototype, 'fill', {
		value: function(value) {
			if (this == null) {
				throw new TypeError('this is null or not defined');
			}

			var O = Object(this),
				len = O.length >>> 0,
				start = arguments[1],
				relativeStart = start >> 0,
				k = relativeStart < 0
				  ? Math.max(len + relativeStart, 0)
				  : Math.min(relativeStart, len);

			var end = arguments[2],
				relativeEnd = end === undefined ? len : end >> 0,
				final = relativeEnd < 0
					  ? Math.max(len + relativeEnd, 0)
					  : Math.min(relativeEnd, len);

			while (k < final) {
				O[k] = value;
				k++;
			}

			return O;
		}
	});
}